import React, { Component } from 'react';
import { withRouter } from '../../utilities/with_router';

class AboutPage extends Component {
	render() {
		return (
			<div className="about-textbox">
				<h1>About</h1>
				<p>
					Several of us who organize to support LGBTQ+ people in prison, jails, and detention are
					working to form a nationwide network of similar orgs and projects.
				</p>
				<p>
					This network might focus on sharing resources, connecting providers of compatible services
					(ex: penpaling + reentry) for the benefit of our people inside, potentially seeding new
					projects in parts of the country lacking them, or more.
				</p>
			</div>
		);
	}
}

const About = withRouter(AboutPage);
export default About;
